/*
 *
 * Package: `@dbh/affiliation-request-page`.
 *
 */const importAffiliationRequestPage=()=>import('./component-632acbef.js'/* webpackChunkName: 'dbh.affiliation-request-page.component' */);const importAffiliationRequestPageReducersAndSagas=()=>import('./reducers-and-sagas-8e867f75.js'/* webpackChunkName: 'dbh.affiliation-request-page.reducers-and-sagas' */);// Only export dynamic imports from the `index.js` of our `@dbh/*-page` packages,
// to avoid the exported code leaking into other pages and increasing the bundle
// size unappropriately.

export { importAffiliationRequestPage, importAffiliationRequestPageReducersAndSagas };
